import { Building2, FolderOpen, Gauge, LineChart, ScrollText, Settings, Users } from 'lucide-react';

import { NavMain, type NavMainItem } from '@/layout/nav/NavMain';

const adminNavigation: NavMainItem[] = [
  {
    title: 'common.Sidebar.TenantManagement',
    url: '/tenants',
    icon: Building2
  },
  {
    title: 'common.Sidebar.UserManagement',
    url: '/users',
    icon: Users
  },
  {
    title: 'common.Sidebar.PartnerContent',
    url: '/partner-content',
    icon: FolderOpen
  },
  {
    title: 'common.Sidebar.Settings',
    url: '/settings',
    icon: Settings
  },
  {
    title: 'common.Sidebar.AuditLogs',
    url: '/audit-logs',
    icon: ScrollText
  },
  {
    title: 'common.Sidebar.Analytics',
    url: '/analytics',
    icon: LineChart
  },
  {
    title: 'common.Sidebar.AiUsage',
    url: '/ai-usage',
    icon: Gauge
  }
];

export function AdminNavSidebar() {
  return (
    <nav className="flex flex-col w-14 bg-sidebar text-sidebar-foreground shrink-0">
      <div className="flex-1 overflow-y-auto">
        <NavMain items={adminNavigation} />
      </div>
    </nav>
  );
}
